module.exports = __webpack_public_path__ + "static/img/IMG-20150921-WA0006.9b414eb1.jpg";